import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import { ReactComponent as ButtonChart } from "../../assets/images/ButtonChart.svg";
import { truncateText } from "../../helpers/helper";

const FileUpload = ({ selectedFile, setSelectedFile }) => {
  const fileInputRef = useRef(null);
  const [resetKey, setResetKey] = useState(0);

  const handleButtonClick = (type) => {
    if (type === "upload") {
      fileInputRef.current.click();
    } else {
      setSelectedFile(null);
      setResetKey((prevKey) => prevKey + 1);
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    console.log("event>>>>", event);
  };

  return (
    <div>
      <input
        key={resetKey}
        type="file"
        accept=".pbix"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button
        sx={{
          width: "auto",
          height: "48px",
          textTransform: "capitalize",
          border: `1px solid #f7954c`,
          backgroundColor: "#fff",
          fontSize: "16px",
          fontWeight: 600,
          letterSpacing: "-0.02em",
          fontFamily: "Montserrat",
          color: "#f7954c",
          textAlign: "center",
          "&:hover": {
            background: "transparent",
            border: `1px solid #f7954c`,
          },
        }}
        variant="outlined"
        startIcon={<ButtonChart />}
        onClick={() => handleButtonClick("upload")}
      >
        {selectedFile?.name
          ? truncateText(selectedFile?.name, 42)
          : "Choose File"}
      </Button>
      {selectedFile?.name && (
        <Button
          sx={{
            width: "auto",
            height: "48px",
            paddingLeft: "20px",
            textTransform: "capitalize",
            backgroundColor: "#fff",
            fontSize: "16px",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            fontFamily: "Montserrat",
            color: "#a50218",
            textAlign: "center",
            "&:hover": {
              background: "transparent",
            },
          }}
          onClick={() => handleButtonClick("delete")}
        >
          Delete
        </Button>
      )}
    </div>
  );
};

export default FileUpload;
